import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';

const UrlEvent = "https://www.aist.asn.au/Events/ASI";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#0b6587',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    backgroundPosition: 'bottom right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    }
  },
  gridLogo: {
    cursor: 'pointer'
  },
  container1: {
    maxWidth: '310px',
    "& img": {
      width: '310px',
      height: '92.8px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '160px',
      "& img": {
        width: '160px',
        height: '46.4px'
      },
    },
  },
  container2: {
    maxWidth: '80px',
    "& img": {
      width: '80px',
      height: '52.17px'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '40px',
      "& img": {
        width: '40px',
        height: '26.085px'
      },
    },
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  gridButtons: {
    textAlign: 'right',
    paddingTop: theme.spacing(2),
  },
  buttonDefault: {
    marginRight: theme.spacing(2),
  },

}));

export default (props) => {
  const classes = useStyles();
  return (
    <AppBar position="static" color="default" className={classes.root} style={{ backgroundImage: `url("/background.banner.jpg")` }} elevation={2}>
      <Container>
        <Grid container direction="row" justify="space-between" alignItems="flex-end">
          <Grid item>
            <div className={classes.container1}><a href={props.userId && `/${props.userId}/home`}><img src="/logo.white.png" alt="ASI2020 Virtual" className={classes.image} /></a></div>
          </Grid>
          <Grid item>
            <div className={classes.container2}><a href={UrlEvent}><img src="/aist.white.png" alt="AIST" className={classes.image} /></a></div>
          </Grid>
        </Grid>
      </Container>
    </AppBar >
  );
}
